import { AxiosRequestConfig } from 'axios';
import { container, TYPES } from  '@/inversifyconfig/container.config';
import { IHttpRequest } from  '@/interfaces/IHttp';

const useHTTP = () => {

    const http = container.get<IHttpRequest>(TYPES.IHttpRequest); 

    function get(url: string, options?: AxiosRequestConfig): Promise<any> {
        return http.get(url, options); 
    }

    function post(url: string, payload: any, options?: AxiosRequestConfig): Promise<any> {
        return http.post(url, payload, options);
    }

    function put(url: string, payload: any, options?: AxiosRequestConfig): Promise<any> {
        return http.put(url, payload, options);
    }

    // delete is a reserved word
    function remove(url: string, payload: any): Promise<any> {
        return http.delete(url, payload);
    }

    async function download(url: string, fileName?: any): Promise<any> {
        return http.get(url, fileName) .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();
        })
        .catch((error) => {
            console.error("Error downloading CSV", error);
        });
    }

    return {get, post, put, remove, download};
}

export default useHTTP;